import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'wpro-error-notification',
  templateUrl: './error-notification.component.html',
  standalone: false
})

export class ErrorNotificationComponent implements OnInit {
  @Output() hideNotificationPopup = new EventEmitter<boolean>();
  @Input() messageFlag: string;
  @Input() errorInfo;
  resetButtonHide: boolean;
  constructor() { }

   ngOnInit(): void {
    this.resetButtonHide = this.messageFlag === '2stepVerification' || this.messageFlag === 'systemUnavailable' || this.messageFlag === 'deliveryPreference' ? true : false ;

    if(this.resetButtonHide){
      setTimeout(() => {
        this.closeNotification();
      }, 4000);
    }
   }

  closeNotification(): void {
    this.hideNotificationPopup.emit(false);
  }

  reloadLoginScreen(): void {
    location.reload();
  }

}
